import {formatPrice, formatToIndianNumber} from '../../../utils/common'

export const MIN_DATE_RANGE = '2020-01-01'

export const CUSTOMER_GROUP_REPORT_COLUMNS = [
  {
    key: 'customer_group_name',
    label: 'Customer Group Name',
    isSorted: true,
    headerStyle: 'min-w-400px',
  },
  {
    key: 'total_order_count',
    label: 'Order',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'freeship_discount',
    label: 'FREESHIP',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sf_discount',
    label: 'SF',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sll_discount',
    label: 'SLL',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: '5offoneorder_discount',
    label: '5%OFFONEORDER',
    isSorted: true,
    headerStyle: 'min-w-180px',
    isColumnTotal: true,
  },
  {
    key: 'other_discount',
    label: 'Other',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'total_discount',
    label: 'Coupon Code Value',
    isSorted: true,
    headerStyle: 'min-w-200px',
    isColumnTotal: true,
  },
  {
    key: 'contributed_discount_percentage',
    label: 'CONTRIBUTED coupon (%)',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: false,
    headerStyle: 'w-220px ',
  },
]

export const CUSTOMER_TYPE_REPORT_COLUMNS = [
  {
    key: 'customer_type',
    label: 'Customer Type',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'total_order_count',
    label: 'Order',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'freeship_discount',
    label: 'FREESHIP',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sf_discount',
    label: 'SF',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sll_discount',
    label: 'SLL',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: '5offoneorder_discount',
    label: '5%OFFONEORDER',
    isSorted: true,
    headerStyle: 'min-w-180px',
    isColumnTotal: true,
  },
  {
    key: 'other_discount',
    label: 'Other',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'total_discount',
    label: 'Coupon Code Value',
    isSorted: true,
    headerStyle: 'min-w-200px',
    isColumnTotal: true,
  },
  {
    key: 'contributed_discount_percentage',
    label: 'CONTRIBUTED coupon (%)',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: false,
    headerStyle: 'w-220px ',
  },
]

export const SALES_REP_TYPE_REPORT_COLUMNS = [
  {
    key: 'sales_rep_type',
    label: 'Sales Rep Type',
    isSorted: true,
    headerStyle: 'min-w-300px',
  },
  {
    key: 'total_order_count',
    label: 'Order',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'freeship_discount',
    label: 'FREESHIP',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sf_discount',
    label: 'SF',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sll_discount',
    label: 'SLL',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: '5offoneorder_discount',
    label: '5%OFFONEORDER',
    isSorted: true,
    headerStyle: 'min-w-180px',
    isColumnTotal: true,
  },
  {
    key: 'other_discount',
    label: 'Other',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'total_discount',
    label: 'Coupon Code Value',
    isSorted: true,
    headerStyle: 'min-w-200px',
    isColumnTotal: true,
  },
  {
    key: 'contributed_discount_percentage',
    label: 'CONTRIBUTED coupon (%)',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: false,
    headerStyle: 'w-220px ',
  },
]

export const SALES_REP_REPORT_COLUMNS = [
  {
    key: 'rep_name',
    label: 'Sales Rep',
    isSorted: true,
    headerStyle: 'min-w-200px',
  },
  {
    key: 'rep_email',
    label: 'Sales Rep Email',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'rep_type',
    label: 'Sales Rep Type',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'total_order_count',
    label: 'Order',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'freeship_discount',
    label: 'FREESHIP',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sf_discount',
    label: 'SF',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: 'sll_discount',
    label: 'SLL',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },
  {
    key: '5offoneorder_discount',
    label: '5%OFFONEORDER',
    isSorted: true,
    headerStyle: 'min-w-180px',
    isColumnTotal: true,
  },
  {
    key: 'other_discount',
    label: 'Other',
    isSorted: true,
    headerStyle: 'min-w-120px',
    isColumnTotal: true,
  },

  {
    key: 'total_discount',
    label: 'Coupon Code Value',
    isSorted: true,
    headerStyle: 'min-w-200px',
    isColumnTotal: true,
  },
  {
    key: 'contributed_discount_percentage',
    label: 'CONTRIBUTED coupon (%)',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: false,
    headerStyle: 'w-220px ',
  },
]

export const COUPON_CODE_REPORT_COLUMNS = [
  {
    key: 'coupon_code',
    label: 'Coupon Code Name',
    isSorted: true,
    headerStyle: 'min-w-400px',
  },
  {
    key: 'total_order_count',
    label: 'Order',
    isSorted: true,
    headerStyle: 'min-w-120px',
  },
  {
    key: 'total_discount',
    label: 'Amount',
    isSorted: true,
    headerStyle: 'min-w-120px',
    style: 'justify-content-center',
  },
  {
    key: 'total_customer_count',
    label: 'Unique Customer',
    isSorted: true,
    headerStyle: 'min-w-200px',
    style: 'justify-content-center',
  },
  {
    key: 'contributed_discount_percentage',
    label: 'CONTRIBUTED COUPON (%)',
    isSorted: false,
    headerStyle: 'min-w-225px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: false,
    headerStyle: 'w-220px ',
  },
]

export const dataToCustomerGroupReportCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'CUSTOMER GROUP NAME': item?.customer_group_name || '',
      ORDER: `${item?.total_order_count || 0}`,
      FREESHIP: `${item?.freeship_coupon_count || 0} / $${item?.freeship_discount || 0}`,
      SF: `${item?.sf_coupon_count || 0} / $${item?.sf_discount || 0}`,
      SLL: `${item?.sll_coupon_count || 0} / $${item?.sll_discount || 0}`,
      '5%OFFONEORDER': `${item?.['5offoneorder_coupon_count'] || 0} / $${
        item?.['5offoneorder_discount'] || 0
      }`,
      OTHER: `${item?.other_coupon_count || 0} / $${item?.other_discount || 0}`,
      'COUPON CODE VALUE': `$${item?.total_discount || 0}`,
      'CONTRIBUTED COUPON (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToCustomerTypeReportCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'CUSTOMER TYPE': item?.customer_type || '',
      ORDER: `${item?.total_order_count || 0}`,
      FREESHIP: `${item?.freeship_coupon_count || 0} / $${item?.freeship_discount || 0}`,
      SF: `${item?.sf_coupon_count || 0} / $${item?.sf_discount || 0}`,
      SLL: `${item?.sll_coupon_count || 0} / $${item?.sll_discount || 0}`,
      '5%OFFONEORDER': `${item?.['5offoneorder_coupon_count'] || 0} / $${
        item?.['5offoneorder_discount'] || 0
      }`,
      OTHER: `${item?.other_coupon_count || 0} / $${item?.other_discount || 0}`,
      'COUPON CODE VALUE': `$${item?.total_discount || 0}`,
      'CONTRIBUTED COUPON (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToSalesRepShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'SALES REP': item?.rep_name || '',
      'SALES REP EMAIL': item?.rep_email || '',
      ORDER: `${item?.total_order_count || 0}`,
      FREESHIP: `${item?.freeship_coupon_count || 0} / $${item?.freeship_discount || 0}`,
      SF: `${item?.sf_coupon_count || 0} / $${item?.sf_discount || 0}`,
      SLL: `${item?.sll_coupon_count || 0} / $${item?.sll_discount || 0}`,
      '5%OFFONEORDER': `${item?.['5offoneorder_coupon_count'] || 0} / $${
        item?.['5offoneorder_discount'] || 0
      }`,
      OTHER: `${item?.other_coupon_count || 0} / $${item?.other_discount || 0}`,
      'COUPON CODE VALUE': `$${item?.total_discount || 0}`,
      'CONTRIBUTED COUPON (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToSalesRepTypeShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'SALES REP TYPE': item?.sales_rep_type || '',
      ORDER: `${item?.total_order_count || 0}`,
      FREESHIP: `${item?.freeship_coupon_count || 0} / $${item?.freeship_discount || 0}`,
      SF: `${item?.sf_coupon_count || 0} / $${item?.sf_discount || 0}`,
      SLL: `${item?.sll_coupon_count || 0} / $${item?.sll_discount || 0}`,
      '5%OFFONEORDER': `${item?.['5offoneorder_coupon_count'] || 0} / $${
        item?.['5offoneorder_discount'] || 0
      }`,
      OTHER: `${item?.other_coupon_count || 0} / $${item?.other_discount || 0}`,
      'COUPON CODE VALUE': `$${item?.total_discount || 0}`,
      'CONTRIBUTED COUPON (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const formatCountAndPrice = (count: number, value: string) =>
  `${formatToIndianNumber(count) || 0}/${formatPrice(value, false) || '$0.00'}`

export const keysToSum = [
  'freeship_discount',
  'freeship_coupon_count',
  'sf_discount',
  'sf_coupon_count',
  'sll_discount',
  'sll_coupon_count',
  '5offoneorder_discount',
  '5offoneorder_coupon_count',
  'other_discount',
  'other_coupon_count',
]

export const dataToCouponCodeReportCSV = (data: any[]) => {
  return data.map((item) => ({
    'Coupon Code Name': item.coupon_code_name || '-',
    'Order Count': item.total_order_count || 0,
    Amount: item.total_discount || 0,
  }))
}
export const ENTITY_PERFORMANCE_CHART_VIEW_OPTIONS = (startDate: string, endDate: string) => {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)
  const timeDiff = endDateObj.getTime() - startDateObj.getTime()
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

  if (daysDiff <= 30) {
    // Up to 1 month
    return [
      {label: 'Day', value: 'day'},
      {label: 'Week', value: 'week'},
    ]
  } else if (daysDiff <= 180) {
    // Between 1 and 6 months
    return [
      {label: 'Week', value: 'week'},
      {label: 'Month', value: 'month'},
    ]
  } else {
    // More than 6 months
    return [
      {label: 'Month', value: 'month'},
      {label: 'Year', value: 'year'},
    ]
  }
}
